<div class="embed-responsive embed-responsive-19by6">
  <!--   <iframe
    class="embed-responsive-item"
    [src]="safeVideoSrc"
    allowfullscreen
    style="width: 100%; height: 500px"
  ></iframe> -->
  <video width="100%" height="500" controls>
    <source [src]="videoSrc" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>
